export const STORE_REVIEW_STUDIO_ID = "demo-studio";
export const STORE_REVIEW_RECITAL_ID = "season-2026-synthetic";
export const STORE_REVIEW_ACCOUNT_KIND = "store-review";
export const STORE_REVIEW_FIXTURE_ID = "store-review";
export const STORE_REVIEW_ACCESS_EXPIRES_AT = "2099-12-31T23:59:59.999Z";
export function normalizedEmail(email) {
    return email.trim().toLowerCase();
}
export function isStoreReviewAccount(identity) {
    return (identity.accountKind === STORE_REVIEW_ACCOUNT_KIND ||
        (identity.configuredEmail !== null &&
            normalizedEmail(identity.targetEmail) === normalizedEmail(identity.configuredEmail)));
}
export function isReviewAccountGrantAllowed(identity, recitalId) {
    return !isStoreReviewAccount(identity) || recitalId === STORE_REVIEW_RECITAL_ID;
}
/** Canonical fixture documents shared by runtime self-heal and operator repair. */
export function storeReviewAccountRecord(uid, email, createdAt) {
    return {
        familyAccountId: uid,
        primaryEmail: normalizedEmail(email),
        accountKind: STORE_REVIEW_ACCOUNT_KIND,
        createdAt,
        disabledAt: null,
        accessExpiresAt: STORE_REVIEW_ACCESS_EXPIRES_AT,
        accessExpiresAtMs: Date.parse(STORE_REVIEW_ACCESS_EXPIRES_AT)
    };
}
export function storeReviewGrantRecord(grantedAt, grantedBy) {
    return {
        recitalId: STORE_REVIEW_RECITAL_ID,
        studioId: STORE_REVIEW_STUDIO_ID,
        grantedAt,
        grantedBy,
        revokedAt: null
    };
}
export function storeReviewFixtureRecord(uid, email, updatedAt) {
    return {
        uid,
        primaryEmail: normalizedEmail(email),
        updatedAt
    };
}
